import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Row, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import ShimmeringEffect from '../../components/shimmering/ShimmeringEffect'
import { formatMRP } from '../../lib/AllGlobalFunction'
import { isSellerPanel } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'

const TopUsedCoupons = ({ values, setFieldValue }) => {
  const [loading, setLoading] = useState(false)
  const { userInfo } = useSelector((state) => state?.user)
  const [data, setData] = useImmer({
    topUsedCoupons: []
  })

  const fetchData = async (days = 'All') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'Dashboard/getTopUsedCoupons',
        queryString: `?days=${days}&sellerId=${
          isSellerPanel ? userInfo?.userId : ''
        }`
      })

      setLoading(false)

      if (response?.status === 200) {
        setData((draft) => {
          draft.topUsedCoupons = response?.data?.data
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return loading ? (
    <ShimmeringEffect />
  ) : (
    <div
      style={{
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
      }}
      className='pv-dashbord-chart-col'
    >
      <Row className='w-100 m-auto py-3'>
        <Col md={12}>
          <div className='d-flex justify-content-between align-items-center'>
            <caption className='cfz-24'>Top Coupons</caption>

            <Dropdown>
              <Dropdown.Toggle className='btn-light' id='dropdown-basic'>
                {values?.topUsedCoupons ? values?.topUsedCoupons : 'All'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('All')
                    setFieldValue('topUsedCoupons', 'All')
                  }}
                >
                  All
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('Today')
                    setFieldValue('topUsedCoupons', 'Today')
                  }}
                >
                  Today
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('7')
                    setFieldValue('topUsedCoupons', 'Last Week')
                  }}
                >
                  Last Week
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('15')
                    setFieldValue('topUsedCoupons', 'Last 15 Days')
                  }}
                >
                  Last 15 Days
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('30')
                    setFieldValue('topUsedCoupons', 'This Month')
                  }}
                >
                  This Month
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('90')
                    setFieldValue('topUsedCoupons', 'Last 3 Month')
                  }}
                >
                  Last 3 Month
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
        <Col md={12}>
          <Table className='align-middle table-list mt-3'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Details</th>
                <th>Total Orders</th>
                <th>Total Selling</th>
              </tr>
            </thead>
            <tbody>
              {data?.topUsedCoupons?.length > 0 ? (
                data?.topUsedCoupons?.map((data) => (
                  <tr key={Math.floor(Math.random() * 100000)}>
                    <td>{data?.coupon}</td>
                    <td>{data?.coupontDetails}</td>
                    <td>{data?.totalOrders}</td>
                    <td>{formatMRP(data?.totalSell)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className='text-center'>
                    No coupons used
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  )
}

export default TopUsedCoupons
